import { useCallback, useState } from 'react';
import { AxiosUserRepository } from '../../infrastructure/AxiosUserRepository';
import { CreateUserUseCase } from '../../usecases/CreateUserUseCase';
import { CreateUserAdapter } from '../../infrastructure/UserCreateAdapter';
import type { CreateUser, User } from '../../domain/user';

interface UseCreateUserState {
    isLoading: boolean
    error: string | null
}

interface UseCreateUserReturn extends UseCreateUserState {
    createUser: (userData: Omit<CreateUser, 'id'>) => Promise<User | null>
}

export function useCreateUser(): UseCreateUserReturn {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const createUser = useCallback(
        async (userData: Omit<CreateUser, 'id'>): Promise<User | null> => {
            setIsLoading(true)
            setError(null)

            try {
                // Convertir CreateUser a User usando el adapter
                const userDomain = CreateUserAdapter.toDomain(
                    userData as Parameters<typeof CreateUserAdapter.toDomain>[0]
                )

                const repository = new AxiosUserRepository()
                const createUserUseCase = new CreateUserUseCase(repository)
                const newUser = await createUserUseCase.execute(userDomain)
                return newUser
            } catch (err) {
                const errorMessage = (err as Error).message
                setError(errorMessage)
                return null
            } finally {
                setIsLoading(false)
            }
        },
        []
    )

    return {
        createUser,
        isLoading,
        error,
    }
}
